export default __webpack_public_path__ + "static/media/linkedinLogo.108a5a85.png";